import React, { useContext, useEffect, useRef, useState } from 'react'
import { Content, ListContent, FilterDiv, FilterImg, FilterText, ButtonCancel, PageBreadcrumb, PageBreadcrumbPrimary, PageBreadcrumbSecondary } from './style'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate } from '../../../components/styles/subheader-style'
import orders from '../../../assets/fashion/TableFashionHeader/orders.svg'
import clock from '../../../assets/fashion/TableFashionHeader/clock.svg'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import diskIcon from '../../../assets/addStockModal/pages/disk.svg'
import { Outlet, useNavigate, useOutletContext, useLocation, useParams } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import LoadingComponent from '../../../components/LoadingComponent'


interface ProductType {
  id: number
  name: string
  quantity: number
}

export interface FashionOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  addedProducts: ProductType[]
  setAddedProducts: React.Dispatch<React.SetStateAction<ProductType[]>>
  handleSave: React.MutableRefObject<() => void>
  handleEditSave: React.MutableRefObject<() => void>
  search?: string
  isSaving?: boolean
  setIsSaving?: React.Dispatch<React.SetStateAction<boolean>>
}

const tabs = [
  { path: '', image: orders, name: 'Pedidos' },
  { path: 'pre-programming', image: clock, name: 'Pré programação' },
]

const FashionSubHeader: React.FC<{
  tabIndexActived: number
  isCreating: boolean
  isEditing: boolean
  onSave?: () => void
  onEditSave?: () => void
}> = ({ tabIndexActived, isCreating, isEditing, onSave, onEditSave }) => {
  const navigate = useNavigate()
  const { orderId } = useParams()

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>
          {isCreating
            ? 'Novo pedido: 123456'
            : isEditing
              ? `Editar pedido: ${orderId}`
              : 'Pedidos fashion'}
        </SectionName>
        {!isCreating && !isEditing && (
          <TabsDiv>
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                $isFirst={index === 0}
                $isLast={index === tabs.length - 1}
                $isActive={index === tabIndexActived}
                onClick={() => {
                  if (index !== tabIndexActived) navigate(tab.path)
                }}
              >
                <img src={tab.image} alt={`${tab.path}-icon`} />
                {tab.name}
              </Tab>
            ))}
          </TabsDiv>
        )}
      </LeftSide>
      <RightSide>
        {!isCreating && !isEditing && (
          <FilterDiv>
            <FilterImg src={filter} alt='filter-icon' />
            <FilterText>Filtrar</FilterText>
          </FilterDiv>
        )}

        {(isCreating || isEditing) && (
          <ButtonCancel
            onClick={() => navigate('/panel/fashion', { replace: true })}
          >
            Cancelar
          </ButtonCancel>
        )}

        <ButtonCreate
          onClick={async () => {
            if (isCreating && onSave) {
              await onSave()
              navigate('/panel/fashion', { replace: true })
            } else if (isEditing && onEditSave) {
              await onEditSave()
              navigate('/panel/fashion', { replace: true })
            } else {
              navigate('/panel/fashion/create')
            }
          }}
        >
          {isCreating ? (
            <>
              <img src={diskIcon} />
              Salvar pedido
            </>
          ) : isEditing ? (
            <>
              <img src={diskIcon} />
              Atualizar pedido
            </>
          ) : (
            '+ Novo pedido'
          )}
        </ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const FashionContent = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [addedProducts, setAddedProducts] = useState<ProductType[]>(() => {
    const saved = sessionStorage.getItem('addedProducts')
    return saved ? JSON.parse(saved) : []
  })

  const handleSave = useRef<() => void>(() => {})

  const handleEditSave = useRef<() => void>(() => {})

  const [isSaving, setIsSaving] = useState(false)

  const { search } = useOutletContext<TypeMainOutlet>()
  const location = useLocation()
  const navigate = useNavigate()

  const isCreating = location.pathname.includes('/panel/fashion/create')
  const isEditing = location.pathname.startsWith('/panel/fashion/edit/')

  useEffect(() => {
    if (location.pathname === '/panel/fashion' || location.pathname === '/panel/fashion/') {
      setTabIndex(0)
    } else if (location.pathname.includes('/panel/fashion/pre-programming')) {
      setTabIndex(1)
    }
  }, [location.pathname])


  useEffect(() => {
    sessionStorage.setItem('addedProducts', JSON.stringify(addedProducts))
  }, [addedProducts])

  return (
    <>
      {isSaving && <LoadingComponent />}
      <FashionSubHeader
        tabIndexActived={tabIndex}
        isCreating={isCreating}
        isEditing={isEditing}
        onSave={() => handleSave.current()}
        onEditSave={() => handleEditSave.current()}
      />

      {(isCreating || isEditing) && (
        <PageBreadcrumb>
          <PageBreadcrumbPrimary>Pedidos fashion</PageBreadcrumbPrimary>
          <PageBreadcrumbSecondary>&gt; {isCreating ? 'Novo pedido' : 'Editar pedido'}</PageBreadcrumbSecondary>
        </PageBreadcrumb>
      )}

      {(isCreating || isEditing) ? (
        <Content>
          <Outlet
            context={{
              tabIndex,
              setTabIndex,
              addedProducts,
              setAddedProducts,
              handleSave,
              handleEditSave,
              search,
              isSaving,
              setIsSaving: (val: boolean) => {
                setIsSaving(val)
              },
            }}
          />
        </Content>
      ) : (
        <ListContent>
          <Outlet
            context={{
              tabIndex,
              setTabIndex,
              addedProducts,
              setAddedProducts,
              handleSave,
              handleEditSave,
              search,
              isSaving,
              setIsSaving: (val: boolean) => {
                setIsSaving(val)
              },
            }}
          />
        </ListContent>
      )}
    </>
  )
}

export default FashionContent
